import React, { useEffect } from 'react';
import GileSearchForm from '../GileSearchForm/GileSearchForm';
import RenderSectionParagraph from '../RenderSectionParagraph/RenderSectionParagraph';
import classes from './SearchSection.module.scss';

const SearchSection = (props) => {
    const { data } = props;
    const { search_block } = data;

    if (!search_block?.visible && !search_block?.gile_search?.visible) return null;
    const { gile_search } = search_block;
    let modifiedInstituteConfig = null;

    if (gile_search) {
        const { fields } = gile_search;
        const isInstituteRequired = fields?.institute_field?.hasOwnProperty("is_required") && fields?.institute_field?.is_required;
        const isLocationRequired = fields?.location_field?.hasOwnProperty("is_required") && fields?.location_field?.is_required;
        const isEducationTypeRequired = fields?.education_type_field?.hasOwnProperty("is_required") && fields?.education_type_field?.is_required;
        const isAcademicYearRequired = fields?.academic_year_field?.hasOwnProperty("is_required") && fields?.academic_year_field?.is_required;
        const isClassRequired = fields?.class_field?.hasOwnProperty("is_required") && fields?.class_field?.is_required;

        const originalInstituteConfig = data?.institute_config;
        modifiedInstituteConfig = {
            ...originalInstituteConfig,
            ...((isInstituteRequired) && {
                institute_id: null,
                institute_code: null,
                institute_name: null,
                institute_label: null,
            }),
            ...((isInstituteRequired || isLocationRequired) && {
                location_id: null,
                location_code: null,
                location_name: null,
                location_label: null,
            }),
            ...((isInstituteRequired || isLocationRequired || isEducationTypeRequired) && {
                education_type_id: null,
                education_type_code: null,
                education_type_name: null,
                education_type_label: null,
            }),
            ...((isInstituteRequired || isLocationRequired || isEducationTypeRequired || isAcademicYearRequired) && {
                ay_id: null,
                ay_code: null,
                ay_name: null,
                ay_label: null,
            }),
            ...((isInstituteRequired || isLocationRequired || isEducationTypeRequired || isAcademicYearRequired || isClassRequired) && {
                gilec_id: null,
                gilec_code: null,
                gilec_name: null,
                gilec_label: null,
            }),
        }
    }

    return (
        <div className={classes.SearchSection}>
            {(gile_search?.visible) ? 
                (<section className={classes.GileSearch}>
                    <div className={classes.Content}>
                        {(gile_search?.title) ? (<h2 className={classes.Title}> {gile_search.title}</h2>) : ""}

                        {(gile_search?.subtitle) ? (<h3 className={classes.SubTitle}>{gile_search.subtitle}</h3>) : ""}
                        
                        {(gile_search?.description?.length > 0) ? 
                            (<div className={classes.Description}>
                                {gile_search.description.map((paragraph, index) => (
                                    <RenderSectionParagraph key={`gile-search-para-${index}`} paragraph={paragraph} />
                                ))}
                            </div>) : null
                        }
                    </div>

                    <GileSearchForm pageData={{
                        ...data,
                        institute_config: modifiedInstituteConfig,
                        }} />
                </section>)
                : null
            }
        </div>
    )
}

SearchSection.propTypes = {}

export default SearchSection;